import { ROUTE_PATH } from 'routes';

/**
 * Detects whether a CMS card points to the Gestopago portal.
 * Card links may come as a plain string (SimpleCard) or as an object (Card).
 */
const isGestopagoCard = (link) => {
  const url = typeof link === 'string' ? link : link?.link || '';
  return url.includes(ROUTE_PATH.GESTOPAGO);
};

export default isGestopagoCard;
